var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FontFamilies as CommonFontFamilies } from '../../themes/default/typography/typography-tokens';
import { css } from 'styled-components';
export { Alignments as TextAlignments, TextTransforms, LetterSpacings, LineHeights, Sizes, Weights } from '../../themes/default/typography/typography-tokens';
export var TextDecorations = {
  Underline: 'underline',
  Overline: 'overline',
  StrikeThrough: 'line-through',
  Solid: 'solid',
  Double: 'double',
  Dotted: 'dotted',
  Dashed: 'dashed',
  Wavy: 'wavy'
};
export var FontFamilies = _objectSpread(_objectSpread({}, CommonFontFamilies), {}, {
  SansSerif: 'SansSerif',
  Serif: 'Serif'
});
export var fontFamily = "\n  DD-TTNorms,\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n";
export var themedFontFamily = function themedFontFamily() {
  var primaryFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD-TTNorms';
  return "\n  ".concat(primaryFont, ",\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n");
};
export var baseStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-family: ", ";\n  color: ", ";\n  margin: 0;\n  padding: 0;\n"])), function (props) {
  return props.size;
}, function (props) {
  return themedFontFamily(props.themeFontFamily);
}, function (props) {
  return props.color;
});
export var DisplayModes = {
  Inline: 'inline',
  InlineBlock: 'inline-block',
  Block: 'block',
  Flex: 'flex'
};
export var TextWeights = {
  Thin: 'Thin',
  Light: 'Light',
  Regular: 'Regular',
  Medium: 'Medium',
  Bold: 'Bold',
  ExtraBold: 'ExtraBold'
}; // To Do (lindsey-menges): remove in v6 when legacy Typography system is removed
// This is an interim change to support Caviar MFP requirements and impending deadline.
// Come back and rethink the font weight strategy across `Text` and the entire project

export var CaviarWeights = {
  Thin: '100',
  Light: '100',
  Regular: '300',
  Medium: '400',
  Bold: '500',
  ExtraBold: '700'
};
export var StandardWeightMappings = {
  100: 'thin',
  200: 'extralight',
  300: 'light',
  400: 'regular',
  500: 'medium',
  600: 'demibold',
  700: 'bold',
  800: 'extrabold',
  900: 'black',
  Black: 900,
  ExtraBold: 800,
  Bold: 700,
  DemiBold: 600,
  Medium: 500,
  Regular: 400,
  Light: 300,
  ExtraLight: 200,
  Thin: 100
};
export var Overflows = {
  Truncate: 'truncate',
  BreakWord: 'break-word',
  Wrap: 'normal'
};